export default __webpack_public_path__ + "static/media/prato.6e81231c.png";